// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-221c2a1c].my-cascader.el-cascader {\n  height: 32px;\n  width: 280px;\n}\n[data-v-221c2a1c].my-cascader.el-cascader .el-input__inner {\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 20px;\n}", ""]);
// Exports
module.exports = exports;
